// extracted by mini-css-extract-plugin
module.exports = {"textComment":"_1nxtx","textCommentIcon":"_7NETe"};